import { render, staticRenderFns } from "./CallOutCard.vue?vue&type=template&id=65ec7025&"
import script from "./CallOutCard.vue?vue&type=script&lang=ts&"
export * from "./CallOutCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports